import { render, staticRenderFns } from "./ViewChannelPartnerCustomerAgreementsPopUp.vue?vue&type=template&id=f75fb088&scoped=true"
import script from "./ViewChannelPartnerCustomerAgreementsPopUp.vue?vue&type=script&lang=js"
export * from "./ViewChannelPartnerCustomerAgreementsPopUp.vue?vue&type=script&lang=js"
import style0 from "./ViewChannelPartnerCustomerAgreementsPopUp.vue?vue&type=style&index=0&id=f75fb088&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f75fb088",
  null
  
)

export default component.exports